import React from 'react';
import { Button, Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
  toastSuccess,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FieldSelectMaterialGroup } from 'shared-pages';
import { useMutation } from '@apollo/client';
import { gqlΙnitializeCollectorsNomoi } from '../regions-tab/graphql';
import { useHandleError } from 'shared-pages/services';
import { TiRefresh } from 'react-icons/ti';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ nomos: likeObj }],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.collectorId) where = { ...where, collectorId: values.collectorId };
  }
  console.log('$$$ [buildWhereFromFilterValues] where', where);
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, isGridInForm, refetch }) => {
  //
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }
  //console.log("filters-init ", initialValues);

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    collectorId: initialValues?.collectorId ?? undefined,
  };

  const { handleGraphqlError } = useHandleError('collector-nomoi');
  const [initNomoiMutation] = useMutation(gqlΙnitializeCollectorsNomoi);

  function handleInitNomoi(event): void {
    initNomoiMutation()
      .then((d) => {
        toastSuccess(t('Επιτυχής Ενημέρωση'));
        refetch();
      })
      .catch((error) => {
        handleGraphqlError('mutation-update', error);
      });
  }

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput as={FormCol} name="searchText" label={t('Αναζήτηση')} type="search" />
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} />

        <FormCol className="d-flex align-items-center">
          <Button variant="outline-primary" className="col-12" onClick={handleInitNomoi} size="sm">
            <TiRefresh size={22} className="mb-1 me-1" /> Συμπλήρωση όσων Νομών Λείπουν
          </Button>
        </FormCol>
      </Row>
    </FormFilterCard>
  );
};
